import ConfirmModal from '@components/modal/ConfirmModal';
import usePrevious from 'lib/src/hooks/usePrevious';
import { useEffect } from 'react';
import { User } from 'src/types/shared/User';
import useDeleteUser from './hooks/useDeleteUser';

const DeleteUserModal: React.FC<DeleteUserProps> = ({ user, closeModal }) => {
    const { handleSubmit, isPosting, error, deleteSuccess } = useDeleteUser(user.id);

    const prevDeleteSuccess = usePrevious(deleteSuccess);

    useEffect(() => {
        if (deleteSuccess && !prevDeleteSuccess) closeModal();
    }, [deleteSuccess, prevDeleteSuccess, closeModal]);

    return (
        <ConfirmModal
            title="Delete admin"
            description={`Are you sure you want to delete '${user.firstName} ${user.lastName}'?`}
            closeModal={closeModal}
            handleSubmit={handleSubmit}
            isPosting={isPosting}
            error={error}
        />
    );
};

interface DeleteUserProps {
    user: User;
    closeModal: () => void;
}
export default DeleteUserModal;
